// src/router/guards/mobileOnlyGuard.js

import { Platform } from 'quasar'

// Bloquea el acceso a un modulo solo-movil cuando se navega desde web.
// En web redirige al inicio; en Capacitor deja pasar.
export function mobileOnlyGuard () {
  // En dev (web) se permite el acceso para pruebas; en produccion sigue siendo solo-movil.
  if (!Platform.is.capacitor && !import.meta.env.DEV) {
    return { name: 'navigation.home' }
  }
  return true
}
